/**
 * BART — utilitaires : tirage déterministe du seuil d'explosion + couleurs.
 *
 * Le seuil hidden d'explosion est dérivé déterministiquement du seed
 * (combinaison maxPumps + trialIdx) pour permettre les tests reproductibles
 * et l'anti-cheat replay côté Edge.
 */
/** Hash 32-bit déterministe (xfnv1a-like). */
function hash32(seed) {
    let h = (seed | 0) ^ 0x9e3779b1;
    h = Math.imul(h ^ (h >>> 16), 0x85ebca6b);
    h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35);
    h ^= h >>> 16;
    return h >>> 0;
}
/**
 * Tire un seuil d'explosion uniforme dans [1, maxPumps] de façon
 * déterministe (seed = combinaison maxPumps + trialIdx + magic).
 */
export function pickExplosionThreshold(maxPumps, seed, salt = 0) {
    const h = hash32(seed * 1_000_003 + maxPumps * 7919 + salt * 31);
    const v = (h % maxPumps) + 1;
    return Math.max(1, Math.min(maxPumps, v));
}
/**
 * Choix couleur ballon par cycle déterministe sur trialIdx.
 */
export function pickColor(trialIdx) {
    const palette = ['amber', 'sage', 'terra', 'air'];
    return palette[trialIdx % palette.length];
}
//# sourceMappingURL=data.js.map